import React, { useState, useEffect } from 'react';
import DateTime from "react-datetime";
import { AsyncTypeahead } from "react-bootstrap-typeahead";
import { apiGetPrompter } from "../../lib/apiUsers";
import { apiReiniciarFolios } from "../../lib/apiAdmin";
import { NotificationManager } from 'react-notifications';
import useLoading from "../../hooks/useLoading";
import moment from "moment";

const Folios = () => {

    const loading = useLoading();

    const [form, setForm] = useState({
        id_apuntador: "",
        fecha: moment()
    });

    const handleFecha = (name, date) => {
        setForm({ ...form, [name]: moment(date) });
    };

    const handleSelectedWorkerOnTypeahead = (obj) => {
        let apuntador = obj[0];
        setForm({ ...form, id_apuntador: apuntador.id });
    };

    const valid = (current) => {
        const today = moment().endOf("day");
        return today.isSameOrAfter(current);
    };

    const [typeahead, setTypeahead] = React.useState({
        isLoading: false,
        options: [],
    });

    const searchApuntador = (search) => {
        apiGetPrompter({ search, limit: 7 })
            .then((response) => {
                if (response.error) {
                } else {
                    setTypeahead({
                        isLoading: false,
                        options: response.rows.map((ap) => ({
                            ...ap,
                            id_name: ap.id + " - " + ap.name,
                        })),
                    });
                }
            })
            .catch();
    };

    const submit = async () => {
        loading.set();
        apiReiniciarFolios(form)
            .then((response) => {
                if (response.error) {
                    NotificationManager.error('Algo falló, favor de intentar más tarde.', '', 5000);
                } else {
                    NotificationManager.success('Folios actualizados correctamente.', '', 5000);
                }
                loading.stop();
            })
            .catch();
    };

    return (
        <div className='mt-3'>
            <div className="card">
                <div className="card-body">
                    <h5>Reiniciar folios</h5>
                    <hr />

                    <div className='row'>
                        <div className="col-md-4">
                            <label>
                                <b>Fecha</b>
                            </label>
                            <DateTime
                                closeOnSelect={true}
                                dateFormat="DD/MMM/YYYY"
                                placeholder="seleccione fecha"
                                timeFormat={false}
                                onChange={(value) => handleFecha("fecha", value)}
                                value={form.fecha}
                                viewMode="days"
                                locale="es"
                                isValidDate={valid}
                                inputProps={{
                                    required: true,
                                    className: "form-control limit",
                                }}
                            />
                        </div>
                        <div className="col-md-4">
                            <label>
                                <b>Apuntador</b>
                            </label>
                            <AsyncTypeahead
                                id="typeaheadApuntador"
                                labelKey="id_name"
                                multiple={false}
                                minLength={1}
                                onChange={handleSelectedWorkerOnTypeahead}
                                isLoading={typeahead.isLoading}
                                filterBy={["name"]}
                                selectHintOnEnter={true}
                                clearButton={false}
                                searchText="Buscando..."
                                options={typeahead.options}
                                placeholder="Seleccionar apuntador"
                                inputProps={{ className: "limit" }}
                                onSearch={(query) => searchApuntador(query)}
                                renderMenuItemChildren={(option, props) => {
                                    return <div key={option.id}>{option.id_name}</div>;
                                }}
                            />
                        </div>
                        <div className="col-md-4 tar mt-2">
                            <label></label>
                            <button
                                className="btn btn-success btn-block"
                                onClick={submit}
                                disabled={!form.fecha || !form.id_apuntador}
                            >
                                Actualizar folios
                            </button>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    );
};

export default Folios;
